import { NumberFormat } from '../../../formatters/utils/NumberFormat'

const DECIMAL_DIGITS_COUNT = 2

interface FormattedValueResult {
  decimalPart: string
  decimalSeparator: string
  integerPart: string
}

export const getFormattedValue = (
  value: number,
  locale: string,
  shortFormat: boolean | undefined,
): FormattedValueResult => {
  const digitLimit = shortFormat ? 0 : DECIMAL_DIGITS_COUNT
  const formattedValue = NumberFormat.getFormattedNumber(value, locale, {
    minimumFractionDigits: digitLimit,
    maximumFractionDigits: digitLimit,
  })
  const decimalSeparator = NumberFormat.getNumberSeparators(locale).decimalSeparator
  const [integerPart, decimalPart] = formattedValue.split(decimalSeparator)

  return {
    decimalPart: decimalPart || '',
    decimalSeparator,
    integerPart,
  }
}
